export const MAIN_PATH = "/";
export const SERVIS_PATH = "/servis";
export const CLIENTS_PATH = "/clients";
export const PROGRAMMES_PATH = "/programmes";
export const REPORT_PATH = "/report";

// paths of service pages
export const USERS_PATH = "/servis/users";
export const REKLAMALAR_PATH = "/servis/reklamalar";
export const FAOLYAT_TURLARI_PATH = "/servis/faoliyat_turlari";
export const HUDUD_PATH = "/servis/hudud";
export const XODIMLAR_PATH = "/workers";
export const VILOYATLAR_PATH = "/servis/viloyatlar";
export const YUNALISHLAR_PATH = "/servis/yunalishlar";
export const SHAHAR_TUMAN_PATH = "/servis/shahar_tuman";
export const LAVOZIM_PATH = "/servis/lavozimlar";

/* ------------------------- paths of client pages ------------------------ */
export const INKOR_MIJOZLAR = "/clients/inkor_mijozlar";
export const REAL_MIJOZLAR = "/clients/real_mijozlar";
export const POTENSIAL_MIJOZLAR = "/clients/potensial_mijozlar";

/* ------------------------ path of programmers pages ----------------------- */

export const YANGI_DASTURLAR = "/programmers/yangi_dasturlar";
export const JARAYONDAGI = "/programmers/jarayondagi";
export const OQITILAYOTGAN = "/programmers/oqitilayotgan";
export const TOPSHIRILGAN = "/programmers/topshirilgan";
export const BEKOR_QILINGAN = "/programmers/bekor_qilingan";
